/*
 * PersonalWidgets Messages
 * This contains all the text for the PersonalWidgets component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  attentionTitle: {
    id: 'apps.harassment-message.attentionTitle',
    defaultMessage: 'ДИҚҚАТ!', // 'DIQQAT!' // Внимание!
  },
  attentionText: {
    id: 'apps.harassment-message.attentionText',
    defaultMessage: 'Агар Сиз Виртуал қабулхонага мурожаат қилганингиздан сўнг таъқибга дучор бўлсангиз бу ҳақида дарҳол хабар беринг'
    // Agar Siz Virtual qabulxonaga murojaat qilganingizdan so'ng ta'qibga duchor bo'lsangiz bu haqida darhol xabar bering 
    // Если Вы после обращения подверглись преследованию, немедленно сообщите об этом
  },
  attentionBtn: {
    id: 'apps.harassment-message.attentionBtn',
    defaultMessage: `Таъқиб ҳақида хабар` // Ta'qib haqida xabar // Сообщение о преследовании
  }
});



// WEBPACK FOOTER //
// ./src/apps/harassment-message/messages.js